import React, { Component } from 'react';
import {
  FormGroup, Input, Button,
  Card,
  CardBody,
  CardTitle,
} from 'reactstrap';

import { actions, Control, Errors } from 'react-redux-form/immutable';
import PropTypes from 'prop-types';
import { Map, fromJS } from 'immutable';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import classnames from 'classnames';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { AddIcon } from '../icon/AddIcon';
import { RemoveIcon } from '../table/RemoveIcon';
import { fieldToNumber, fieldTrimmed } from './formUtilities';
import { SingleResultGrid } from '../grid/SingleResultGrid';
import { Column } from '../grid/Column';
import { ResultGrid } from '../grid/ResultGrid';
import { Loading } from '../loadbar/Loading';
import { volVisibleColumns, volSort, minColumns } from '../../redux/EditReduxConstant';

const resolveSignif = ({ value }) => {
  if (value == null) {
    return null;
  }
  return value ? 'Y' : 'N';
};

const defaultMap = fromJS({});

class AssociatedVolcanoControlUnwrapped extends Component {
  constructor(props) {
    super(props);
    this.searchVolcanoes = this.searchVolcanoes.bind(this);
    this.addVolcano = this.addVolcano.bind(this);
    this.handleToggleColumns = this.handleToggleColumns.bind(this);
    this.resolveRemove = this.resolveRemove.bind(this);
    this.toggleSearch = this.toggleSearch.bind(this);
    this.renderAddButton = this.renderAddButton.bind(this);
    this.state = {
      volcanoes: Map(),
      searchVisible: false,
      searchInput: '',
    };
  }

  componentDidMount() {
    const { volcano } = this.props;
    this.setState((state) => {
      const volcanoId = volcano.get('id');
      const volcanoes = volcanoId ? state.volcanoes.set(`${volcanoId}`, volcano) : state.volcanoes;
      return {
        volcanoes,
      };
    });
  }

  searchVolcanoes() {
    const { searchVolcanoes } = this.props;
    const { searchInput } = this.state;
    searchVolcanoes({
      queryParameters: {
        op: 'or',
        nameInclude: fieldTrimmed(searchInput),
        id: fieldToNumber(searchInput),
        country: fieldTrimmed(searchInput),
        year: fieldToNumber(searchInput),
      },
    });
  }

  addVolcano(vol) {
    const { volcano, change, model } = this.props;
    const id = vol ? vol.get('id') : '';
    this.setState((state) => {
      const volcanoes = state.volcanoes.filter(existing => existing.get('id') === volcano.get('id'));
      return {
        volcanoes: vol ? volcanoes.set(`${id}`, vol) : volcanoes,
      };
    }, () => {
      change(`${model}.volcanoEventId`, `${id}`);
    });
  }

  resolveRemove({ row }) {
    if (row.get('id') == null) {
      return null;
    }
    return (<RemoveIcon handleClick={() => this.addVolcano()} />);
  }

  handleToggleColumns({ visibleColumns, sort }) {
    const {
      visibleColumns: preVisibleColumns, sort: prevSort, sortData, toggleColumns,
    } = this.props;
    let changed = false;
    if (!visibleColumns.sort().equals(preVisibleColumns.sort())) {
      toggleColumns(visibleColumns);
      changed = true;
    }
    if (!sort.equals(prevSort)) {
      sortData(sort);
      changed = true;
    }
    return changed;
  }

  toggleSearch() {
    this.setState(({ searchVisible: prev }) => ({ searchVisible: !prev }));
  }

  renderAddButton({ row }) {
    const { volcanoId } = this.props;
    if (`${row.get('id')}` !== volcanoId) {
      return (<AddIcon handleClick={() => this.addVolcano(row)} />);
    }
    return (<div />);
  }

  render() {
    const {
      volcanoSearching, volcanoSearchResults, volcanoId, sort, valid, visibleColumns,
    } = this.props;
    const { volcanoes, searchVisible } = this.state;
    return (
      <Card>
        <CardBody>
          <CardTitle tag="h2">Associated Volcano Event</CardTitle>
          <SingleResultGrid data={volcanoes.get(volcanoId) ? volcanoes.get(volcanoId) : defaultMap}>
            <Column id="remove" cell={this.resolveRemove} width={50}><RemoveIcon /></Column>
            <Column id="id" width={100}>ID</Column>
            <Column id="significant" cell={resolveSignif} width={100}>Significant</Column>
            <Column id="year" width={50} helpModalId="year">Year</Column>
            <Column id="month" width={50} helpModalId="month">Mo</Column>
            <Column id="day" width={50} helpModalId="day">Dy</Column>
            <Column id="country" width={150}>Country</Column>
            <Column id="name" width={150} helpModalId="volLocName">Name</Column>
          </SingleResultGrid>
          <div className="form-group sr-only">
            <Control type="hidden" model=".volcanoEventId" />
          </div>
          <Errors
            model=".volcanoEventId"
            component="div"
            wrapper={({ children }) => <div className={classnames({ 'invalid-feedback': true, 'haz-associated-table-error': !valid })}>{children}</div>}
          />
          {searchVisible ? (
            <Card>
              <CardBody>
                <CardTitle tag="h2" className="haz-close-title">
                  <span>Search</span>
                  <button type="button" className="close" aria-label="Close" onClick={this.toggleSearch}>x</button>
                </CardTitle>
                <div className="haz-assoc-search-container">
                  <div className="form-inline">
                    <FormGroup className="mb-2 mr-sm-2 mb-sm-0">
                      <Input disabled={volcanoSearching} onChange={(e) => { this.setState({ searchInput: e.target.value }); }} type="text" />
                    </FormGroup>
                    <Button disabled={volcanoSearching} onClick={this.searchVolcanoes}>Search</Button>
                  </div>

                  <div className="haz-assoc-search">
                    {volcanoSearching ? (<Loading />) : (
                      <ResultGrid
                        data={volcanoSearchResults}
                        sort={sort}
                        handleColumnsToggle={this.handleToggleColumns}
                        columnChooser
                        visibleColumns={visibleColumns}
                        defaultColumns={volVisibleColumns}
                        defaultSort={volSort}
                        minColumns={minColumns}
                      >
                        <Column id="add" width={50} alwaysVisible cell={this.renderAddButton}><AddIcon /></Column>
                        <Column id="id" width={100} sortable>ID</Column>
                        <Column id="significant" cell={resolveSignif} width={150} sortable>Significant</Column>
                        <Column id="year" width={100} sortable helpModalId="year">Year</Column>
                        <Column id="month" width={100} sortable helpModalId="month">Mo</Column>
                        <Column id="day" width={100} sortable helpModalId="day">Dy</Column>
                        <Column id="country" width={150} sortable>Country</Column>
                        <Column id="name" width={150} sortable helpModalId="volLocName">Name</Column>
                      </ResultGrid>
                    )}
                  </div>
                </div>
              </CardBody>
            </Card>
          ) : (<Button onClick={this.toggleSearch}>Search</Button>)}
        </CardBody>
      </Card>
    );
  }
}


AssociatedVolcanoControlUnwrapped.propTypes = {
  model: PropTypes.string.isRequired,
  volcano: ImmutablePropTypes.map.isRequired,
  searchVolcanoes: PropTypes.func.isRequired,
  volcanoSearching: PropTypes.bool.isRequired,
  volcanoSearchResults: ImmutablePropTypes.list.isRequired,
  change: PropTypes.func.isRequired,
  volcanoId: PropTypes.string.isRequired,
  sortData: PropTypes.func.isRequired,
  sort: ImmutablePropTypes.list.isRequired,
  valid: PropTypes.bool.isRequired,
  visibleColumns: ImmutablePropTypes.list.isRequired,
  toggleColumns: PropTypes.func.isRequired,
};


const mapStateToProps = (state, { model }) => ({
  volcanoId: state.getIn([model, 'volcanoEventId']) ? state.getIn([model, 'volcanoEventId']) : '',
  valid: state.get('forms')[model].volcanoEventId.valid,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  change: actions.change,

}, dispatch);

export const AssociatedVolcanoControl = connect(mapStateToProps, mapDispatchToProps)(AssociatedVolcanoControlUnwrapped);
